// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3Xtf4","selects":"Documents_selects__1rWmW"};